import {Component, Input, OnInit} from '@angular/core';
import {VoucherService} from "../../../services/voucher.service";

@Component({
  selector: 'app-voucher-history',
  templateUrl: './voucher-history.component.html',
  styleUrls: ['./voucher-history.component.scss']
})
export class VoucherHistoryComponent implements OnInit {
  @Input() voucher;
  @Input() isFirstLevel = true;

  constructor(private voucherService: VoucherService) {
  }

  ngOnInit() {
    this.voucherService.addExtraDataForOne(this.voucher);
    this.voucher.isCollapsed = true;
  }

}
